import {
   Autocomplete as MantineAutocomplete,
   AutocompleteProps,
} from '@mantine/core'
import styles from './Autocomplete.module.scss'
import cn from 'classnames'
import { useState } from 'react'

interface IAutocomplete extends AutocompleteProps {
   shouldLeftSectionBeFocused?: boolean
}

export const Autocomplete = ({
   onBlur,
   onFocus,
   leftSection,
   shouldLeftSectionBeFocused = false,
   ...rest
}: IAutocomplete) => {
   const [isFocused, setIsFocused] = useState(false)

   return (
      <MantineAutocomplete
         classNames={{
            input: cn(styles['text-input']),
            label: 'text-white/90 font-medium mb-1.5',
            dropdown: 'bg-black rounded-lg p-2 z-[99999]',
            description: 'pt-0.5',
         }}
         leftSection={
            leftSection && (
               <div
                  className={cn({
                     'text-[#a684ff]': shouldLeftSectionBeFocused && isFocused,
                  })}
               >
                  {leftSection}
               </div>
            )
         }
         inputWrapperOrder={['label', 'input', 'description', 'error']}
         onFocus={(e) => {
            setIsFocused(true)
            onFocus?.(e)
         }}
         onBlur={(e) => {
            setIsFocused(false)
            onBlur?.(e)
         }}
         {...rest}
      />
   )
}
